import React, { useState } from 'react';
import { Outlet } from "react-router-dom";
import { Box, List, ListItem, ListItemIcon, ListItemText, Typography, IconButton, CssBaseline } from '@mui/material';
import { styled } from '@mui/material/styles';
import MuiDrawer from '@mui/material/Drawer';
import ListItemButton from '@mui/material/ListItemButton';
import { COLORS } from '../assets/colors';
import { MEDIAS } from '../assets/medias';
import NavigateBeforeRoundedIcon from '@mui/icons-material/NavigateBeforeRounded';
import ChevronRightRoundedIcon from '@mui/icons-material/ChevronRightRounded';
import Avatar from '@mui/material/Avatar';
import AutoAwesomeRoundedIcon from '@mui/icons-material/AutoAwesomeRounded';
import DashboardOutlinedIcon from '@mui/icons-material/DashboardOutlined';
import FolderOutlinedIcon from '@mui/icons-material/FolderOutlined';
import RestoreOutlinedIcon from '@mui/icons-material/RestoreOutlined';
import SupportOutlinedIcon from '@mui/icons-material/SupportOutlined';
import TuneOutlinedIcon from '@mui/icons-material/TuneOutlined';
import Button from '@mui/material/Button';
import AddOutlinedIcon from '@mui/icons-material/AddOutlined';
import Fab from '@mui/material/Fab';
import { useNavigate } from 'react-router-dom';
import TopBar from '../components/MainLayout/TopBar';
import { Link } from 'react-router-dom';



const drawerWidth = 250;

const openedMixin = (theme) => ({
    width: drawerWidth,
    transition: theme.transitions.create('width', {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.enteringScreen,
    }),
    overflowX: 'hidden',
});

const closedMixin = (theme) => ({
    transition: theme.transitions.create('width', {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
    }),
    overflowX: 'hidden',
    width: `calc(${theme.spacing(7)} + 1px)`,
    [theme.breakpoints.up('sm')]: {
        width: `calc(${theme.spacing(8)} + 1px)`,
    },
});

const DrawerHeader = styled('div')(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    padding: theme.spacing(0, 1),
    ...theme.mixins.toolbar,
}));

const Drawer = styled(MuiDrawer, { shouldForwardProp: (prop) => prop !== 'open' })(
    ({ theme, open }) => ({
        width: drawerWidth,
        flexShrink: 0,
        whiteSpace: 'nowrap',
        boxSizing: 'border-box',
        ...(open && {
            ...openedMixin(theme),
            '& .MuiDrawer-paper': openedMixin(theme),
        }),
        ...(!open && {
            ...closedMixin(theme),
            '& .MuiDrawer-paper': closedMixin(theme),
        }),
    }),
);


const MainLayout = (props) => {
    const [hoveredIndex, setHoveredIndex] = useState(null); // Suivi de l'élément survolé
    // const theme = useTheme();
    const [open, setOpen] = useState(true);
    const navigate = useNavigate(); // Utilisé pour naviguer vers la page ConverseQuery

    const menuItems = [
        { text: 'ConverseQuery', path: '/' },
        { text: 'Liveboard', path: '/liveboard' },
        { text: 'Use Cases', path: '/usecases' },
        { text: 'Audit Trails', path: '/auditrails' },
    ];

    const handleDrawerToggle = () => {
        setOpen(!open); // Inverse l'état du drawer
    };

    const handleNewConversation = () => {
        navigate('/dashboard'); // Redirige vers ConverseQuery
        setTimeout(() => {
            if (window.clearChat) {
                window.clearChat(); // Appelle la fonction clear si elle existe
            }
        }, 100);
    };

    return (
        <Box sx={{ display: "flex", bgcolor: COLORS.GRAY_BG, minHeight: "100vh", flexDirection: 'row' }}>
            <Box sx={{ display: 'flex', flexDirection: 'row', width: '100%' }}>
                <Box sx={{ display: 'flex' }}>
                    <CssBaseline />
                    <Drawer variant="permanent" open={open} sx={{
                        '& .MuiDrawer-paper': {
                            borderRight: 'none',
                            backgroundColor: COLORS.GRAY_BG, // Couleur de fond personnalisée du Drawer
                            display: 'flex',
                            flexDirection: 'column', // Utilisation de flex pour empiler le contenu et le footer
                        },
                    }}>
                        <Box sx={{ flex: 1 }}>
                            <DrawerHeader sx={{ display: 'flex', alignItems: 'center', textAlign: 'center' }}>
                                <IconButton
                                    color="inherit"
                                    aria-label="open drawer"
                                    onClick={handleDrawerToggle}
                                    edge="start"
                                    sx={{
                                        position: 'fixed',
                                        top: 16,
                                        left: 16,
                                        zIndex: 1201,
                                        pl: { xs: '8px', sm: '15px' },
                                        // ml:'0.5px'
                                    }}
                                >
                                    {open ? <img
                                        src={MEDIAS.sparkles_auth}
                                        alt="Sparkles"
                                        style={{ height: '30px', width: '36px', objectFit: 'contain', marginLeft: '12%', marginRight: '8%' }}
                                    /> : <Avatar sx={{ bgcolor: COLORS.WHITE, height: '30px', width: '30px' }}>
                                        <ChevronRightRoundedIcon sx={{ color: COLORS.BLACK_TEXT }} />
                                    </Avatar>}
                                    {open && (
                                        <Typography color={COLORS.BLACK_TEXT} variant="caption" sx={{ fontWeight: 700, fontFamily: 'Inter, Roboto', fontSize: '13px' }}>
                                            ConverseQuery
                                        </Typography>
                                    )}
                                </IconButton>
                                <IconButton onClick={handleDrawerToggle} sx={{ marginTop: '3%' }}>
                                    {open ?
                                        <Avatar sx={{ bgcolor: COLORS.WHITE, height: '30px', width: '30px' }}>
                                            <NavigateBeforeRoundedIcon sx={{ color: COLORS.BLACK_TEXT, fontSize: '20px' }} />
                                        </Avatar>
                                        : null
                                    }
                                </IconButton>
                            </DrawerHeader>
                            <List>
                                {menuItems.map((item, index) => (
                                    <ListItem
                                        key={item.text}
                                        disablePadding
                                        onMouseEnter={() => setHoveredIndex(index)} // Met à jour l'index survolé
                                        onMouseLeave={() => setHoveredIndex(null)} // Réinitialise l'index survolé
                                    >
                                        <Link to={`/dashboard${item.path}`} style={{ all: 'unset', textDecoration: 'none' }}>
                                            <ListItemButton
                                                sx={{
                                                    minHeight: 48,
                                                    justifyContent: open ? 'initial' : 'center',
                                                    px: 2.5,
                                                    '&:hover': {
                                                        backgroundColor: COLORS.GRAY_HOVER, // Change la couleur au survol
                                                        cursor: 'pointer',
                                                        borderRadius: '50px',
                                                        // ml: '5px',
                                                        mr: '5px',

                                                    },
                                                }}
                                            >
                                                <ListItemIcon
                                                    sx={{
                                                        minWidth: 0,
                                                        mr: open ? 1 : 'auto',
                                                        justifyContent: 'center',
                                                    }}
                                                >
                                                    {index === 0 ? (
                                                        <Avatar sx={{ bgcolor: COLORS.WHITE, height: '32px', width: '32px' }}>
                                                            <AutoAwesomeRoundedIcon sx={{ color: COLORS.GRAY_ICONS, fontSize: '18px' }} />
                                                        </Avatar>
                                                    ) : index === 1 ? (
                                                        <Avatar sx={{ bgcolor: COLORS.WHITE, height: '32px', width: '32px' }}>
                                                            <DashboardOutlinedIcon sx={{ color: COLORS.GRAY_ICONS, fontSize: '18px' }} />
                                                        </Avatar>
                                                    ) : index === 2 ? (
                                                        <Avatar sx={{ bgcolor: COLORS.WHITE, height: '32px', width: '32px' }}>
                                                            <FolderOutlinedIcon sx={{ color: COLORS.GRAY_ICONS, fontSize: '18px' }} />
                                                        </Avatar>
                                                    ) : (
                                                        <Avatar sx={{ bgcolor: COLORS.WHITE, height: '32px', width: '32px' }}>
                                                            <RestoreOutlinedIcon sx={{ color: COLORS.GRAY_ICONS, fontSize: '18px' }} />
                                                        </Avatar>
                                                    )}
                                                </ListItemIcon>
                                                <ListItemText
                                                    sx={{
                                                        opacity: open ? 1 : 0,
                                                    }}
                                                > <Typography color={COLORS.BLACK_TEXT} variant="caption" sx={{ fontWeight: 500, fontFamily: 'Inter, Roboto', fontSize: '13px', color: COLORS.BLACK_TEXT }}>
                                                        {item.text}
                                                    </Typography>
                                                </ListItemText>
                                                {hoveredIndex === index && open && (
                                                    <ListItemIcon
                                                        sx={{
                                                            minWidth: 0,
                                                            ml: 'auto', // Pousse l'icône à droite
                                                        }}
                                                    >
                                                        <ChevronRightRoundedIcon
                                                            sx={{
                                                                color: COLORS.GRAY, // Changez cette couleur selon vos besoins
                                                                fontSize: '18px',
                                                            }}
                                                        />
                                                    </ListItemIcon>
                                                )}
                                            </ListItemButton>
                                        </Link>
                                    </ListItem>
                                ))}
                            </List>
                        </Box>

                        {/* Footer de Drawer */}
                        <Box sx={{ mt: 'auto', textAlign: 'center' }}>
                            <List>
                                {['Help Center', 'Réglages & préférences'].map((text, index) => (
                                    <ListItem
                                        key={`secondLoop-${index}`} // Préfixe différent pour la deuxième boucle
                                        disablePadding
                                        onMouseEnter={() => setHoveredIndex(`secondLoop-${index}`)}
                                        onMouseLeave={() => setHoveredIndex(null)}
                                    >
                                        <ListItemButton
                                            sx={{
                                                minHeight: 48,
                                                justifyContent: open ? 'initial' : 'center',
                                                px: 2.5,
                                                '&:hover': {
                                                    backgroundColor: COLORS.GRAY_HOVER,
                                                    cursor: 'pointer',
                                                    borderRadius: '50px',
                                                },
                                            }}
                                        >
                                            <ListItemIcon
                                                sx={{
                                                    minWidth: 0,
                                                    mr: open ? 1 : 'auto',
                                                    justifyContent: 'center',
                                                }}
                                            >
                                                {index === 0 ? (
                                                    <Avatar sx={{ bgcolor: COLORS.WHITE, height: '32px', width: '32px' }}>
                                                        <SupportOutlinedIcon sx={{ color: COLORS.GRAY_ICONS, fontSize: '18px' }} />
                                                    </Avatar>
                                                ) : (
                                                    <Avatar sx={{ bgcolor: COLORS.WHITE, height: '32px', width: '32px' }}>
                                                        <TuneOutlinedIcon sx={{ color: COLORS.GRAY_ICONS, fontSize: '18px' }} />
                                                    </Avatar>
                                                )}
                                            </ListItemIcon>
                                            <ListItemText
                                                sx={{
                                                    opacity: open ? 1 : 0,
                                                }}
                                            >
                                                <Typography variant="caption" sx={{ fontWeight: 500, fontFamily: 'Inter, Roboto', fontSize: '13px', color: COLORS.BLACK_TEXT }}>
                                                    {text}
                                                </Typography>
                                            </ListItemText>
                                            {hoveredIndex === `secondLoop-${index}` && open && (
                                                <ListItemIcon
                                                    sx={{
                                                        minWidth: 0,
                                                        ml: 'auto', // Pousse l'icône à droite
                                                    }}
                                                >
                                                    <ChevronRightRoundedIcon sx={{ color: COLORS.GRAY, fontSize: '18px' }} />
                                                </ListItemIcon>
                                            )}
                                        </ListItemButton>
                                    </ListItem>
                                ))}
                            </List>
                            {
                                open ?
                                    <Button
                                        sx={{
                                            boxShadow: 'none',
                                            bgcolor: COLORS.PINK_INTELCIA,
                                            borderRadius: '50px',
                                            // p: '0px 13% 0px 13%',
                                            fontSize: "12px",
                                            textTransform: 'capitalize',
                                            fontFamily: 'Inter, Roboto !important',
                                            width: '90%',
                                            mb: 2,
                                            // pr: '10px'
                                            marginRight: '5px',
                                            '&:hover': {
                                                cursor: 'pointer',
                                            },
                                        }} variant="contained" startIcon={<AddOutlinedIcon />}
                                        onClick={handleNewConversation}>
                                        Nouvelle conversation
                                    </Button>
                                    :
                                    <Fab aria-label="add" sx={{
                                        bgcolor: COLORS.PINK_INTELCIA, height: '35px', width: '35px', mb: 2, mt: '10%', boxShadow: 'none', '&:hover': {
                                            backgroundColor: COLORS.ORANGE_LINEAR,
                                            cursor: 'pointer',
                                        },

                                    }}>
                                        <AddOutlinedIcon sx={{ color: COLORS.WHITE }} />
                                    </Fab>
                            }

                        </Box>
                    </Drawer>
                </Box>
                <Box sx={{ width: '100%', padding: "10px 10px  10px 0" }}>
                    <Box sx={{ minHeight: "100%", width: 'auto', borderRadius: "10px", backgroundColor: "white" }}>
                        <TopBar />
                        <Outlet />
                    </Box>

                </Box>
            </Box>

        </Box >

    )


}


export default MainLayout;

